import { Observable } from 'rxjs';
import { Province } from '@domain/aggregates';

export abstract class ProvincesDataSource {
  abstract listProvinces(): Observable<Province[]>;
}
